/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PeriodDateType {
    DAYS = 'DAYS',
    MONTHS = 'MONTHS',
    YEARS = 'YEARS',
}
